import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PromptEventService {
  private promptClickedSource = new Subject<string>();

  // Observable that components can subscribe to
  promptClicked$ = this.promptClickedSource.asObservable();

  // Method to emit the prompt text when a suggested prompt is clicked
  emitPromptClicked(promptText: string): void {
    this.promptClickedSource.next(promptText);
  }
}
